var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoomTypeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2956 2.97634C12.5486 2.34122 11.4514 2.34122 10.7044 2.97634L3.70445 8.92838C3.25754 9.30837 3 9.86542 3 10.452V20.5013C3 21.6059 3.89543 22.5013 5 22.5013H19C20.1046 22.5013 21 21.6059 21 20.5013V10.452C21 9.86542 20.7425 9.30837 20.2956 8.92838L13.2956 2.97634ZM12 4.5L19 10.452V20.5013H15.0029V16.718C15.0029 15.6134 14.1075 14.718 13.0029 14.718H11C9.89543 14.718 9 15.6134 9 16.718V20.5013H5V10.452L12 4.5ZM11 20.5013H13.0029V16.718L11 16.718V20.5013Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomTypeIcon);
export default __webpack_public_path__ + "static/media/room-type-icon.80e51afe4b2676693f4b609a3c872658.svg";
export { ForwardRef as ReactComponent };